import React, { useEffect, useState, useCallback } from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { Form } from "reactstrap";
import FormInput from "../../form-components/InputComponent";
import { Icon, Button, RSelect } from "../../../components/Component";
import { Row, Col } from "reactstrap";
import FormSelect from "../../form-components/SelectComponent";
import usersApis from "../../../api/master/users";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import sites from "../../../api/master/sites";
import Swal from "sweetalert2";
import GstinVerificationModal from "../../../components/GstinVerificationModal";
import FormDatePicker from "../../form-components/DatePicker";
import useSequence from "../../../hooks/useSequence";
interface SelectOptions {
  label: string;
  value: string;
}
const ContractorInformation = (props: any) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
    reset,
    trigger,
    getValues,
    clearErrors,
  } = useFormContext();

  const { hasSequence } = useSequence(166);
  const [gstinModal, setGstinModal] = useState(false);
  const [states, setStates] = useState<SelectOptions[]>([]);
  const [districtOptions, setDistrictOptions] = useState<SelectOptions[]>([]);
  const [countries, setCountries] = useState<SelectOptions[]>([]);
  const [workingSites, setWorkingSites] = useState<any>([]);
  const [previousBusinessType, setPreviousBusinessType] = useState<string>("");
  const [isSettingGstData, setIsSettingGstData] = useState(false);
  const [gstVerificationCancelled, setGstVerificationCancelled] = useState(false);

  const businessType = watch("bussinessType");
  const countryWatch = watch("country");
  const stateWatch = watch("state");
  useEffect(() => {
    if (countryWatch) {
      fetchStatesByCountry(countryWatch);
    }
  }, [countryWatch]);
  useEffect(() => {
    if (stateWatch) {
      getDistricts(stateWatch);
    }
  }, [stateWatch]);
  useEffect(() => {
    getCountries();
    fetchWorkingSites();
    fetchStatesByCountry("1");
  }, []);
  useEffect(() => {
    if (businessType === "registered") {
      setValue("applicationAccess", "true");
    }
  }, [businessType, setValue]);
  const onStateChange = (e: any) => {
    getDistricts(e);
  };

  useEffect(() => {
    if (previousBusinessType && previousBusinessType !== businessType) {
      // Only reset GST-related fields, not all fields
      resetGstRelatedFields();
      setGstVerificationCancelled(false);
    }
    setPreviousBusinessType(businessType);
  }, [businessType]);

  const resetGstRelatedFields = () => {
    clearErrors();
    // Only reset GST-specific fields
    const gstFieldsToReset = [
      "gstin",
      "cin",
      "incorporationDate",
      "pan",
      "companyName",
      "country",
      "state",
      "district",
      "city",
      "area",
      "mailingAddressLine1",
      "pincode",
      "lastFYTurnover",
      "applicationAccess",
    ];

    gstFieldsToReset.forEach((field) => {
      setValue(field, "", { shouldValidate: false });
    });

    if (businessType === "registered") {
      setValue("applicationAccess", "true", { shouldValidate: false });
    } else {
      setValue("applicationAccess", "", { shouldValidate: false });
    }

    // setTimeout(() => {
    //   trigger();
    // }, 100);
  };

  const isGstVerified = () => {
    const values = getValues();
    return !!values.gstin && !!values.pan;
  };

  useEffect(() => {
    if (businessType === "registered" && !isGstVerified()) {
      setGstinModal(true);
      setGstVerificationCancelled(false);
    } else {
      setGstinModal(false);
    }
  }, [businessType]);

  const fetchWorkingSites = async (selectedOptions: SelectOptions[] = []) => {
    try {
      const { data, status, message } = await sites.fetchSites();
      if (status) {
        setWorkingSites(
          data.map((item: any) => ({
            label: item.name,
            value: item.siteID?.toString(),
          }))
        );
        // if (selectedOptions.length > 0) {
        //   setValue("siteAccessibility", selectedOptions);
        // }
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.message, "error");
    }
  };

  const getCountries = async () => {
    try {
      const _countries = await usersApis.getCountrys();
      if (_countries.status) {
        if (_countries.data.length > 0) {
          const transformedData = _countries.data.map((item: any) => ({
            value: item.countryId.toString(),
            label: item.countryName,
          }));
          setCountries(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const fetchStatesByCountry = async (countryId: string) => {
    try {
      const data = await usersApis.getStatesByCountry(countryId);
      const stateOptions = data?.data?.map((state: any) => ({
        value: state.stateId.toString(),
        label: state.stateName,
      }));
      if (stateOptions.length > 0) setStates(stateOptions);
    } catch (error) { }
  };
  const getDistricts = async (stateID: any) => {
    try {
      const districts = await usersApis.getDistrictsByState(stateID);
      console.log(districts);
      if (districts.status) {
        if (districts.data.length > 0) {
          const transformedData = districts.data.map((item: any) => ({
            value: item.districtId.toString(),
            label: item.districtName,
          }));
          setDistrictOptions(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  const submitForm = (data: any) => {
    console.log("General Info Data:", data);
    props.next();
  };

  const findOptionValue = (label: string, options: SelectOptions[]) => {
    const found = options.find((option) => option.label === label);
    return found ? found.value : "";
  };

  const handleGSTVerification = async (gstData: any) => {
    console.log("Verified GST Data:", gstData);

    setIsSettingGstData(true);
    setGstVerificationCancelled(false);
    clearErrors();

    // Set all values first without validation
    const updates = [
      () => setValue("gstin", gstData.gstin || "", { shouldValidate: false }),
      () => setValue("pan", gstData.pan || "", { shouldValidate: false }),
      () =>
        setValue("companyName", gstData.LegalName || "", {
          shouldValidate: false,
        }),
      () =>
        setValue("country", findOptionValue(gstData.country, countries) || "", {
          shouldValidate: false,
        }),
      () =>
        setValue("state", findOptionValue(gstData.state, states) || "", {
          shouldValidate: false,
        }),
      () =>
        setValue(
          "district",
          findOptionValue(gstData.district, districtOptions) || "",
          { shouldValidate: false }
        ),
      () => setValue("city", gstData.city || "", { shouldValidate: false }),
      () => setValue("area", gstData.area || "", { shouldValidate: false }),
      () =>
        setValue("mailingAddressLine1", gstData.addressLine1 || "", {
          shouldValidate: false,
        }),
      () =>
        setValue("pincode", gstData.zipPincode || "", {
          shouldValidate: false,
        }),
    ];

    // Execute all setValue calls
    updates.forEach((update) => update());

    // Wait for React to process the state updates
    setTimeout(() => {
      // Trigger validation for all relevant fields
      const fieldsToValidate = [
        "gstin",
        "pan",
        "companyName",
        "country",
        "state",
        "district",
        "city",
        "area",
        "mailingAddressLine1",
        "pincode",
      ];

      trigger(fieldsToValidate).then((isValid) => {
        console.log("Validation result after GST data:", isValid);
        setIsSettingGstData(false);
      });
    }, 300);
  };

  return (
    <>
      {/* <FormProvider {...methods}> */}
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <h5 className="mb-2">Legal Information</h5>
        <Row className="gy-4">
          <Col md="3">
            <FormSelect
              name="bussinessType"
              label="Business Type"
              required={true}
              options={[
                { label: "Registered", value: "registered" },
                { label: "Unregistered", value: "unregistered" },
              ]}
              placeholder="Select Business Type"
            />
          </Col>
          {/* Conditional Fields */}
          {businessType === "registered" && (
            <>
              <Col md="3">
                <FormInput
                  name="gstin"
                  label="GSTIN"
                  required
                  type="text"
                  placeholder="Auto-filled GSTIN"
                  disabled={!gstVerificationCancelled || isGstVerified()}
                />
              </Col>

              <Col md="3">
                <FormInput
                  name="cin"
                  label="CIN"
                  type="text"
                // placeholder="Auto-filled CIN"
                // disabled
                />
              </Col>

              <Col md="3">
                <FormDatePicker
                  name="incorporationDate"
                  label="Incorporation Date"
                  required
                />
              </Col>

              <Col md="3">
                <FormInput
                  name="lastFYTurnover"
                  label="Last FY Turn Over (INR)"
                  type="text"
                  placeholder="Enter Last FY Turnover"
                  pattern={/^\d+$/}
                />
              </Col>
            </>
          )}
          {(businessType === "registered" ||
            businessType === "unregistered") && (
              <Col md="3">
                <FormInput
                  name="pan"
                  label="PAN"
                  required
                  type="text"
                  pattern={/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                  placeholder={
                    businessType === "registered"
                      ? "Auto-filled PAN"
                      : "Enter PAN"
                  }
                  disabled={businessType === "registered" && (!gstVerificationCancelled || isGstVerified())}
                />
              </Col>
            )}

          {businessType === "unregistered" && (
            <Col md="3">
              <FormInput
                name="cin"
                label="CIN"
                type="text"
                placeholder="Enter CIN"
              />
            </Col>
          )}
        </Row>

        <h5 className="mt-4 mb-2">General Information</h5>
        <Row className="gy-4">
          {!hasSequence && (
            <Col md="3">
              <FormInput
                name="referenceID"
                label="Contractor ID"
                type="text"
                pattern={/^[a-zA-Z0-9./_-]+$/}
                required={true}
                // maxLength={10}
                placeholder="Enter Contractor ID"
              />
            </Col>
          )}
          <Col lg="3">
            <FormSelect
              name="contractorType"
              label="Contractor Type"
              required={true}
              options={[
                { label: "General Contractor", value: "General Contractor" },
                { label: "Sub Contractor", value: "Sub Contractor" },
                { label: "Self Construction", value: "Self Construction" },
              ]}
              placeholder="Enter Contractor Terms"
            />
          </Col>
          <Col lg="3">
            <FormInput
              name="companyName"
              label="Contractor Name"
              required={true}
              placeholder="Enter Contractor Name"
              pattern={/^[A-Za-z\s.&/-]+$/}
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^A-Za-z\s.&/-]/g, ""); // Removes invalid characters
              }}
              disabled={businessType === "registered"}
            />
          </Col>
          {/* <Col md="3">
            <FormInput
              name="contactPerson"
              // disabled={action === "view"}
              label="Contact Person"
              required={true}
              type="text"
              maxLength={50}
              placeholder="Enter Contact Person"
              pattern={/^[A-Za-z\s]+$/}
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Removes invalid characters
              }}
            />
          </Col>
          <Col md="3">
            <FormMultiSelect
              name="siteAccessibility"
              label="Site Accessibility"
              required={true}
              options={workingSites}
              placeholder="Select Site Accessibility"
            />
          </Col>
          <Col md="3">
            <FormInput
              name="email"
              // disabled={action === "view"}
              required={true}
              label="Email"
              type="email"
              placeholder="Enter Email"
              pattern={/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/}
            />
          </Col>
          <Col md="3">
            <FormInput
              name="phoneNumber"
              label="Phone Number"
              // disabled={action === "view"}
              required={true}
              type="text"
              // pattern={/^\d+$/} // Allows only digits
              pattern={/^[6-9]\d{9}$/}
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
              placeholder="Enter Phone Number"
            />
          </Col> */}
          <Col lg="3">
            <FormSelect
              name="country"
              label="Country"
              options={countries}
              required={true}
              placeholder="-Select-"
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col md="3">
            <FormSelect
              name="state"
              label="State"
              required={true}
              options={states}
              placeholder="Select State"
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col md="3">
            <FormSelect
              name="district"
              label="District"
              options={districtOptions}
              required={true}
              placeholder="Select District"
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col md="3">
            <FormInput
              name="city"
              label="City"
              required={true}
              // disabled={action === "view"}
              placeholder="Enter City"
              type="text"
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col lg="3">
            <FormInput
              name="area"
              // disabled={action === "view"}
              label="Area"
              required={true}
              placeholder="Enter Area"
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col md="3">
            <FormInput
              name="mailingAddressLine1"
              // disabled={action === "view"}
              label="Address Line 1"
              required={true}
              placeholder="Enter Area"
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col md="3">
            <FormInput
              name="pincode"
              // disabled={action === "view"}
              label="Zip/Pincode"
              required={true}
              type="text"
              pattern={/^\d+$/} // Allows only digits
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
              placeholder="Enter Zip or pin code"
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col md="3">
            <FormInput
              name="yearsInBusiness"
              // disabled={action === "view"}
              label="Years in Business"
              type="text"
              placeholder="Enter Years in Business"
              pattern={/^\d+$/} // Allows only digits
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
            // disabled={businessType === "registered"}
            />
          </Col>
          <Col md="3">
            <FormSelect
              name="applicationAccess"
              label="Application Access"
              required={true}
              options={[
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
              ]}
              placeholder="Select Access"
            />
          </Col>
        </Row>
        <Row className="gy-4 mt-1">
          <Col>
            <Button color="primary" type="submit">
              Next
            </Button>
          </Col>
        </Row>
      </form>
      {/* </FormProvider> */}
      {/* GstinVerificationModal usage: */}
      <GstinVerificationModal
        isOpen={gstinModal}
        toggle={() => {
          setGstinModal(!gstinModal);
          if (gstinModal && !isGstVerified()) {
            setGstVerificationCancelled(true);
          }
        }}
        onVerified={handleGSTVerification}
        countries={countries}
        states={states}
        districts={districtOptions}
        source="contractors"
      />
    </>
  );
};

export default React.memo(ContractorInformation);
